import { Spin, Upload, DatePicker } from 'antd';
import { useState } from "react";
import PopComponent from "../../pages/popContent";
import CustomModal from "../../hoc/CustomModal";
import moment from 'moment';

const FormInput = ({ label, value, onPaste, isEdit, checkValue, type, min, checkTitle, name, handleZip, className = "form_group", icon, error, handleVideoUpload, progress, uploadInput, fixClass,inputtype, ...rest }) => {
    const [errors, setError] = useState({});
    const [modalName, setModalName] = useState("UserInfo");
    let Modal = PopComponent[modalName];
    const [openModal, setModalOpen] = useState(false);

    const handleZipUpload = (file) => {
        if (!file.type.match(/zip/g)) {
            handleOpenModal('ErrorPop', { header: "Info", body: 'Please add only zip files' })
            return Upload.LIST_IGNORE;
        }
    };

    const handleOpenModal = (type, data) => {
        let flag = 0;
        switch (type) {
            case 'ErrorPop': {
                setModalName(type);
                setError(data)
                setModalOpen(!openModal);
                break;
            }
            default: {
                setModalName(type);
                setModalOpen(!openModal);
                break;
            }
        }
        if (flag === 1) {
            setModalName(type);
            setModalOpen(!openModal);
        }
    };
    const disabledDate = (current) => {
        return current && current < moment().startOf('day');
      };

    return (
        <>
            <div className={className}>
                <div className="form_label">
                    <label htmlFor="">{icon} {label}</label>
                </div>
                <div className="form_input flex_direction_column">
                    <span className={`position_relative rise_link_input_div d_flex fullWidth ${name === 'individual_course_fees' ? "course_fees_input" : ""}`}>
                        {name === "individual_course_fees" ?
                            <span className="position_absolute">$</span>
                            :
                            ""
                        }
                           {inputtype !== "date"  && <input min={min} autoComplete={"off"} onPaste={onPaste} name={name} className={`form_control ${fixClass}`} {...rest} type={`${type ? type : "text"}`} value={value} />}
                       
                        {
                            uploadInput && (
                                <Upload showUploadList={false} customRequest={(e) => handleZip({ type: "zip", file: e, id: rest.id })} beforeUpload={handleZipUpload} accept=".zip,.rar,.7zip" className={`browseBtn cursor_pointer ${progress?.[rest.id] ? 'pointer_event_none' : ''}`}>
                                    {progress?.[rest.id] ? <Spin /> : "Browse"}
                                </Upload>)
                        }
                         {inputtype === "date" && <DatePicker className='program_start' disabledDate={disabledDate}  name="program_start_date" value={value ? moment(value,"MM/DD/YYYY") : ""} {...rest}/>}
                    </span>
                    {
                        checkTitle && (
                            <div className="day_checkbox">
                                <div className="checkbox_btn">
                                    <input {...rest} name="cohort" type="checkbox" checked={checkValue} id="cohort_checkbox" />
                                    <span></span>
                                </div>
                                <label htmlFor="cohort_checkbox" className='d_flex white_space_nowrap pl_3'>{checkTitle}</label>
                            </div>
                        )
                    }
                    {
                        isEdit && (
                            <div className="day_checkbox">
                                <label htmlFor="cohort_checkbox" className='d_flex white_space_nowrap course_id pl_3'>Course ID: {isEdit}</label>
                            </div>
                        )
                    }
                    <div className="errMsg">{error}</div>
                </div>
                {
                    Modal && (
                        <CustomModal className={`${modalName === 'EditThoughtLeader' || modalName === 'AddThoughtLeader' ? "ant-modal modal peak_model thought_leader_modal" : "modal skill_model"} ${modalName === 'ErrorPop' ? 'errorPop' : ''}`} handleOpen={handleOpenModal} open={openModal}>
                            <Modal
                                error={errors}
                                handleOpenModal={handleOpenModal}
                            />
                        </CustomModal>
                    )
                }
            </div>
        </>
    )
};

export default FormInput